export default function FilmCardSkeleton() {
  return (
    <div className="rounded-lg overflow-hidden border border-background-200 bg-background-50">
      <div className="w-full aspect-[2/3] skeleton-block"></div>
      <div className="p-3.5 space-y-2.5">
        <div className="h-3.5 w-3/4 rounded skeleton-block"></div>
        <div className="h-3 w-1/2 rounded skeleton-block"></div>
        <div className="flex justify-between pt-1">
          <div className="h-3 w-1/3 rounded skeleton-block"></div>
          <div className="h-3 w-10 rounded skeleton-block"></div>
        </div>
      </div>
    </div>
  );
}